export const DEFAULT_ROUTE = "/";
export const SKILLS = "skills";
export const MATRIX = "matrix";
export const SETTINGS = "settings";
export const EDIT_MATRIX = "edit_matrix";
export const OVERVIEW = "overview";
